import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.token.colorFillTertiary};
  padding: 18px 24px;
`;
